export const PLATFORMS_GET = 'platformsGet';
export const JOB_CREATE = 'jobCreate';
export const STATUS_GET = 'statusGet';
export const LIBRARY_GET = 'libraryGet';
